import { render, staticRenderFns } from "./InlineBoxSimpleLayout.vue?vue&type=template&id=281ada9c"
import script from "./InlineBoxSimpleLayout.vue?vue&type=script&lang=js"
export * from "./InlineBoxSimpleLayout.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxSimpleLayout.vue?vue&type=style&index=0&id=281ada9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports